<template>
  <FaIcon :icon="['fas', 'bell-exclamation']" />
</template>
